import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { FaGoogle, FaMailBulk } from 'react-icons/fa';

import Modal from './Modal';
import TextField from './TextField';
import { emailPasswordSignIn, emailPasswordSignUp, signInWithGoogle } from '../Firebase/utils';
import { useAppDispatch } from '../store/store';
import { setUser } from '../store/features/UserSlice';
import { User } from '../types';

const SignUpWithEmailComponent = ({isSignUpModalOpen, onClose}: {isSignUpModalOpen: boolean, onClose: () => void}) => {

  const [isModalOpen, setIsModalOpen] = useState(isSignUpModalOpen);
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const dispatch = useAppDispatch();

  const emailPasswordSignUpMutation = useMutation({
    mutationFn: async () => {
      if (password !== confirmPassword) {
        throw new Error('Passwords do not match');
      }
      if (!email.includes('@')) {
        throw new Error('Invalid email address');
      }
      const user = await emailPasswordSignUp(email, password);
      return user;
    },
    onSuccess: (user) => {
      dispatch(setUser(user));
      onClose()
    },
    onError: (error) => {
      setError(error.message);
    }
  });

  const googleSignInMutation = useMutation({
    mutationFn: async () => {
      const user = await signInWithGoogle();
      return user;
    },
    onSuccess: (user) => {
      dispatch(setUser(user));
      onClose();
    },
    onError: (error) => {
      setError(error.message);
    }
  });

  return (
    <Modal title='Create Account' onClose={onClose} openState={isSignUpModalOpen} left={'-left-5'}>
      <TextField label={'Email'} placeholder={'Enter your email'} inputValue={email} setInputValue={(value) => {setEmail(value)}}/>
      <TextField type='password' label={'Password'} placeholder={'Password'} inputValue={password} setInputValue={(value) => {setPassword(value)}}/>
      <TextField type='password' label={'Confirm Password'} placeholder={'Confirm Password'} inputValue={confirmPassword} setInputValue={(value) => {setConfirmPassword(value)}}/>
        <button onClick={() => emailPasswordSignUpMutation.mutate()} className='flex flex-row gap-10 w-full items-center justify-center mt-10 py-2 text-lg md:text-xl uppercase font-SoulGaze tracking-wider text-slate-300 border border-slate-400 rounded-md'>
          <p className='flex gap-4 items-center text-[#3da8e2] font-BardotBold tracking-[0.25rem]'><FaMailBulk className='text-2xl'/>Create Account</p>
        </button>
        <button onClick={() => googleSignInMutation.mutate()} className='flex flex-row gap-10 w-full items-center justify-center mt-10 py-2 text-lg md:text-xl uppercase font-SoulGaze tracking-wider text-slate-300 border border-slate-400 rounded-md'>
          <p className='flex gap-4 items-center text-[#3da8e2] font-BardotBold tracking-[0.25rem]'><FaGoogle className='text-2xl'/>Signin With Google</p>
        </button>
    </Modal>
  )
}

export default SignUpWithEmailComponent;